/* eslint-disable max-lines */
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Actions} from '../../../common/actions';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Modal, Popup, Icon, Input, Table, Checkbox, Label} from 'semantic-ui-react';
import {VerticalTimeline, VerticalTimelineElement} from 'react-vertical-timeline-component';
import {dateFormatPicker, noTimeZoneShortISODate, dateFormatShow} from '../../../common/constants/datesFormat';
import {scopes, resources} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {importsTrackingStatus} from '../../../common/dictionaries/parameters';

import 'react-vertical-timeline-component/style.min.css';
import './dashboard.scss';

const {
  fetchPartsImportsInvoiceTracking,
  updatePartsImportsInvoiceTracking,
  createPartsImportsInvoiceTrackingPartial,
  setTimerRequest,
} = Actions;

export const TrackingModal = ({invoice, search, key}) => {
  const permissions = useSelector((state) => state.session.permissions);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [dateToChange, setDateToChange] = React.useState('');
  const [partialDateToChange, setPartialDateToChange] = React.useState([]);
  const [lastPartialValue, setLastPartialValue] = React.useState(false);
  const loading = useSelector((state) => state.partsImportsInvoices.loadingTracking);
  const invoiceTracking = useSelector((state) => state.partsImportsInvoices.invoiceTracking);
  const [observationValue, setObservationValue] = useState('');

  const openTrackingModal = (e) => {
    e.preventDefault();
    setOpen(true);
    dispatch(setTimerRequest(false));
    dispatch(fetchPartsImportsInvoiceTracking(invoice));
  };

  const closeTrackingModal = (e) => {
    e.preventDefault();
    setOpen(false);
    dispatch(setTimerRequest(true));
    search();
  };

  useEffect(() => {
    const tracking = invoiceTracking.find((track) => track.status === importsTrackingStatus.nationalization);
    setObservationValue(tracking?.observations);
  }, [invoiceTracking]);

  const handleUpdateTracking = (e, action, realValue, status, partial, observation) => {
    e.preventDefault();
    if (dateToChange || realValue || action === 'BACK' ||
      (action === 'SEND' && status === importsTrackingStatus.labeling)) {
      const newDate = dateToChange ? dateToChange : realValue;
      const data = {
        'action': action,
        'invoice': invoice,
        'partial': partial,
        'observations': observation,
      };
      if (action !== 'BACK' && status !== importsTrackingStatus.labeling) {
        data.date = moment(newDate).format(noTimeZoneShortISODate);
      }
      dispatch(updatePartsImportsInvoiceTracking(data));
      setDateToChange('');
    }
  };

  useEffect(() => {
    const partials = invoiceTracking.map((item) => {
      return item.partial;
    }).filter((value, index, self) => {
      return self.indexOf(value) === index && value !== null;
    });
    partials.forEach((partial) => {
      const partialState = invoiceTracking.find((item) => {
        return item.partial === partial && item.current_status === 'S';
      });
      partialDateToChange.push({
        'partial': partial,
        'dateToChange': partialState.etacd_real,
        'observations': partialState.observations,
      });
    });
  }, []);

  const handleDateToChangeValue = (newDateValue) => {
    setDateToChange(newDateValue);
  };

  const getPartialDateToChange = (partial) => {
    const returnPartialDateToChange = partialDateToChange.find((x) => x.partial === partial);
    return returnPartialDateToChange ? returnPartialDateToChange.dateToChange : null;
  };

  const handlePartialDateToChangeValue = (partial, value) => {
    const partialDateToChangeIndex = partialDateToChange.findIndex((x) => {
      return x.partial === partial;
    });
    const tempPartialDateToChangeeList = [...partialDateToChange];
    tempPartialDateToChangeeList[partialDateToChangeIndex] =
      {...partialDateToChange[partialDateToChangeIndex], 'dateToChange': value};
    setPartialDateToChange(tempPartialDateToChangeeList);
  };

  const nextPartialCode = (currentTracking) => {
    const partialsCount = currentTracking.partialized === 'N' ? 1 : currentTracking.partial_no + 1;
    return partialsCount;
  };

  const handleCreatePartial = (e, currentTracking) => {
    const partialCode = `${currentTracking.invoice}_${nextPartialCode(currentTracking)}`;
    const data = {
      'invoice': invoice,
      'partialCode': partialCode,
      'partialNo': nextPartialCode(currentTracking),
      'partialLast': lastPartialValue ? 'S' : 'N',
    };
    dispatch(createPartsImportsInvoiceTrackingPartial(data));
    partialDateToChange.push({'partial': partialCode, 'dateToChange': null, 'observations': ''});
  };
  
  const getTimelineCardStyle = (track, currentStatusSequence) => {
    return track.sequence < currentStatusSequence ||
      ((track.status === importsTrackingStatus.movilization ||
        track.status === importsTrackingStatus.cargo_recieved) && track.current_status === 'S') ?
      {'background': 'rgb(16, 204, 82)', 'color': '#fff'} :
      {'background': 'rgb(33, 150, 243)', 'color': '#fff'};
  };

  const getIconStyle = () => {
    return {'background': 'rgb(33, 150, 243)', 'color': 'white', 'bordeRadius': '0.20em'};
  };

  const getLastModificationSection = (modificationDate, modificationUser) => {
    const formattedModificationDate = moment(modificationDate).format(dateFormatShow);
    return <div>Actualizado el {formattedModificationDate} por {modificationUser}</div>;
  };

  const changeLastPartialCheckValue = (e, target) => {
    e.preventDefault();
    setLastPartialValue(target.checked);
  };

  const showCreatePartialInput = (current) => {
    return (
      current.current_status === 'S' ?
        current.partial_last === 'N' ?
          <div className='flex middle'>
            <Input label={'CREAR PARCIAL'} readOnly
              value={`${current.invoice}_${nextPartialCode(current)}`} />
            {current.partial_no >= 1 ?
              <div style={{'marginLeft': '10px'}}>
                <Label>¿Es el último parcial?
                  <Checkbox style={{'marginLeft': '10px'}} checked={lastPartialValue}
                    onChange={(e, target) => changeLastPartialCheckValue(e, target)} />
                </Label>
              </div> : null
            }
            <Icon size='big' name='add-circle' color='white' link
              onClick={(e) => handleCreatePartial(e, current)} />
          </div> : <div>Parcialización completa</div> :
        ''
    );
  };

  const showTrackingCard = (tracking) => {
    if (tracking.status !== importsTrackingStatus.cargo_recieved && tracking.partial === null) {
      if (tracking.partialized === 'S') {
        if (tracking.invoice_type === 'I') {
          if (tracking.status === importsTrackingStatus.nationalization ||
            tracking.status === importsTrackingStatus.movilization) {
            return false;
          }
        } else {
          if (tracking.status === importsTrackingStatus.movilization) {
            return false;
          }
        }
      }
      return true;
    }
    if (tracking.status === importsTrackingStatus.cargo_recieved && tracking.partial === null) {
      return true;
    }
    return false;
  };

  const handlePartialObservationValue = (partial, input) => {
    const partialDateToChangeIndex = partialDateToChange.findIndex((x) => {
      return x.partial === partial;
    });
    const tempPartialDateToChangeeList = [...partialDateToChange];
    tempPartialDateToChangeeList[partialDateToChangeIndex] =
      {...partialDateToChange[partialDateToChangeIndex], 'observations': input.value};
    setPartialDateToChange(tempPartialDateToChangeeList);
  };

  const getPartialObservation = (partial) => {
    const returnPartialDateToChange = partialDateToChange.find((x) => x.partial === partial);
    return returnPartialDateToChange ? returnPartialDateToChange.observations : '';
  };

  const changeObservationValue = (e, value) => {
    e.preventDefault();
    setObservationValue(value);
  };

  const getPartialsSummarySection = (partials) => {
    return <Table striped textAlign='center'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={2}>Código Parcial</Table.HeaderCell>
          <Table.HeaderCell>Estado</Table.HeaderCell>
          <Table.HeaderCell>Ubicación</Table.HeaderCell>
          <Table.HeaderCell>ETA CD Estimada</Table.HeaderCell>
          <Table.HeaderCell>ETA CD Real</Table.HeaderCell>
          <Table.HeaderCell>Recibido</Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {partials.map((partial, index) => {
          const partialState = invoiceTracking.find((item) => {
            return item.partial === partial && item.current_status === 'S';
          });
          const partialInputsDisabled = (partialState.etacd_real &&
            partialState.status === importsTrackingStatus.movilization) ||
          partialState.status === importsTrackingStatus.cargo_recieved ? true : false;
          const sendType = partialState.status === importsTrackingStatus.nationalization &&
          partialState.invoice_type === 'I' ? 'SEND' : 'SAVE';
          return <Table.Row style={partialState.status === importsTrackingStatus.cargo_recieved ?
            {'background': 'rgb(16, 204, 82, 0.8)', 'color': '#fff'} : {}} key={`track-modal-row-${index}`}>
            <Table.Cell width={2}>
              <h4>{partial}</h4>
            </Table.Cell>
            <Table.Cell>
              {partialState.status_name}
            </Table.Cell>
            <Table.Cell>
              {partialState.location}
            </Table.Cell>
            <Table.Cell>
              <Input className={'disabled-background'} disabled
                value={moment(partialState.etacd_estimated).format(dateFormatShow)} />
            </Table.Cell>
            <Table.Cell>
              <DatePicker locale='es' disabled={partialInputsDisabled}
                className={partialInputsDisabled ? 'disabled-background' : ''}
                customInput={<Input readOnly icon='calendar' size='small' className='keep' />}
                dateFormat={dateFormatPicker} todayButton='Hoy'
                selected={getPartialDateToChange(partial) ? moment(getPartialDateToChange(partial)).toDate() :
                  partialState.etacd_real ? moment(partialState.etacd_real).toDate() : null}
                onChange={(value) => handlePartialDateToChangeValue(partial, value)}
              />
            </Table.Cell>
            <Table.Cell>
              <Input className={'disabled-background'} disabled
                value={partialState.etacd_check ? moment(partialState.etacd_check).format(dateFormatShow) : ''} />
            </Table.Cell>
            <Table.Cell width={1}>
              <Popup pinned on='click' trigger={<Icon name='comment' link size='large' color='red' ></Icon>}
                position='top left' style={{'minWidth': '300px'}}>
                <Popup.Header>Observación</Popup.Header>
                <Popup.Content style={{'paddingBottom': '5px'}}>
                  <Input fluid value={getPartialObservation(partial) || partialState.observations}
                    disabled={partialState.status === importsTrackingStatus.cargo_recieved ||
                      partialState.status === importsTrackingStatus.movilization}
                    onChange={(e, value) => handlePartialObservationValue(partial, value)} />
                </Popup.Content>
              </Popup>
            </Table.Cell>
            <Table.Cell width={1}>
              {partialInputsDisabled ? '' :
                <Icon size='large' name='check' link
                  onClick={(e) =>
                    handleUpdateTracking(e, sendType, getPartialDateToChange(partial), partialState.status, partial,
                      getPartialObservation(partial))}/>}
            </Table.Cell>
          </Table.Row>;
        })
        }
      </Table.Body>
    </Table>;
  };

  const getTimelineCard = (tracking, current, index) => {
    const dateState = tracking.sequence < current.sequence ? true : false;
    const disabledBackround = tracking.sequence < current.sequence ? 'disabled-background' : '';
    let dateLabel = '';
    let estimatedValue = '';
    let realValue = '';
    let iconName = 'check';
    let hideTrackingDates = false;
    switch (tracking.status) {
      case importsTrackingStatus.dispatch_confirmation:
        dateLabel = 'ETD';
        iconName = 'assignment-turned-in';
        estimatedValue = current.etd_estimated;
        realValue = current.etd_real;
        break;
      case importsTrackingStatus.transit:
        dateLabel = 'ETA';
        iconName = tracking.transport === 'A' ? 'flight-takeoff' : 'ship';
        estimatedValue = current.eta_estimated;
        realValue = current.eta_real;
        break;
      case importsTrackingStatus.nationalization:
        dateLabel = 'ETA CD';
        iconName = 'flag';
        estimatedValue = current.etacd_estimated;
        realValue = current.etacd_real;
        break;
      case importsTrackingStatus.country_arrival:
        dateLabel = 'INEN';
        iconName = 'flag';
        realValue = current.inen_date;
        break;
      case importsTrackingStatus.labeling:
        dateLabel = 'ETA CD';
        iconName = 'labeling';
        estimatedValue = current.etacd_estimated;
        realValue = current.etacd_real;
        break;
      case importsTrackingStatus.movilization:
        dateLabel = 'ETA CD';
        iconName = 'local-shipping';
        hideTrackingDates = true;
        break;
      case importsTrackingStatus.cargo_recieved:
        dateLabel = 'Recibido';
        estimatedValue = current.etacd_check;
        break;
      default:
        break;
    }
    const partials = invoiceTracking.map((item) => {
      return item.partial;
    }).filter((value, index, self) => {
      return self.indexOf(value) === index && value !== null;
    });
    
    return (<>
      <VerticalTimelineElement className='vertical-timeline-element--work' key={`vertical-timeline-element-${index}`}
        contentStyle={getTimelineCardStyle(
          tracking, current ? current.sequence : null)}
        iconStyle={getTimelineCardStyle(
          tracking, current ? current.sequence : null)}
        icon={<Icon name={iconName} size='huge' className='timeline-icon' />}>
        <h3 className='vertical-timeline-element-title'>{tracking.status_name}</h3>
        <h4 className='vertical-timeline-element-subtitle'>{tracking.location}</h4>
        {hideTrackingDates ? '' :
          <>
            {tracking.status !== importsTrackingStatus.labeling ?
              <>
                {tracking.status === importsTrackingStatus.nationalization &&
                  tracking.invoice_type === 'N' ?
                  <>
                    {showCreatePartialInput(tracking)}
                    <div style={{'marginTop': '5px'}}>
                      <label>Observaciones:</label>
                      <Input fluid value={observationValue} onChange={(e, i) => changeObservationValue(e, i.value)}
                        className={disabledBackround} disabled={dateState || loading} />
                    </div>
                    {partials.length > 0 ? getPartialsSummarySection(partials) : ''}
                  </> : tracking.status === importsTrackingStatus.nationalization ? <div style={{'marginTop': '5px'}}>
                    <label>Observaciones:</label>
                    <Input fluid value={observationValue} onChange={(e, i) => changeObservationValue(e, i.value)}
                      className={disabledBackround} disabled={dateState || loading} />
                  </div> : ''
                }
                {
                  tracking.partialized === 'S' && tracking.status === importsTrackingStatus.nationalization ? '' :
                    <div className='flex middle' style={{'marginTop': '1em'}}>
                      {
                        tracking.status === importsTrackingStatus.country_arrival ? '' :
                          <div style={{'marginRight': '10px'}}>
                            {tracking.status !== importsTrackingStatus.cargo_recieved ?
                              <label style={{'marginRight': '1em'}}>{dateLabel} Estimada:</label> : ''}
                            <Input className='disabled-background' disabled label={dateLabel}
                              value={estimatedValue ? moment(estimatedValue).format(dateFormatShow) : ''} />
                          </div>
                      }
                      {tracking.status !== importsTrackingStatus.cargo_recieved ?
                        <div className={tracking.partialized === 'S' && 'flex middle'}>
                          <label style={{'marginRight': '1em', 'text-wrap': 'nowrap'}}>{dateLabel} Real:</label>
                          {tracking.current_status === 'S' ?
                            <DatePicker locale='es' className={disabledBackround} disabled={dateState || loading}
                              customInput={<Input readOnly icon='calendar' size='small' />}
                              dateFormat={dateFormatPicker} todayButton='Hoy'
                              selected={dateToChange ? moment(dateToChange).toDate() :
                                realValue ? moment(realValue).toDate() : ''}
                              onChange={handleDateToChangeValue}
                            /> :
                            <Input className={disabledBackround} disabled
                              value={realValue ? moment(realValue).format(dateFormatShow) : ''} />
                          }
                        </div> : ''
                      }
                    </div>
                }
              </> :
              <div style={{'marginTop': '5px'}}>
                {showCreatePartialInput(tracking)}
                {partials.length > 0 ? getPartialsSummarySection(partials) : ''}
              </div>
            }
            <hr style={{'height': '3px', 'background': 'white'}} />
            {loading ? '' :
              <div className='flex middle' style={{'justifyContent': 'space-between'}}>
                {tracking.modification_date ?
                  getLastModificationSection(tracking.modification_date, tracking.modification_user) : ''}
                {
                  hasAccessPermission(permissions, resources.PartsImportsTrackingDashboard, scopes.Edit) &&
                  ((tracking.current_status === 'S' && tracking.status !== importsTrackingStatus.cargo_recieved)) ?
                    <div>
                      {tracking.status === importsTrackingStatus.dispatch_confirmation ? '' :
                        <Icon name='undo' size='large' style={getIconStyle()} link
                          onClick={(e) => handleUpdateTracking(e, 'BACK', realValue, tracking.status)} />}
                      {tracking.status === importsTrackingStatus.labeling ? '' :
                        <Icon name='save' size='big' style={getIconStyle()} link
                          onClick={(e) =>
                            handleUpdateTracking(e, 'SAVE', realValue, tracking.status, null, observationValue)} />}
                      <Icon name='check' size='big' style={getIconStyle()} link
                        onClick={(e) =>
                          handleUpdateTracking(e, 'SEND', realValue, tracking.status, null, observationValue)} />
                    </div> :
                    ''
                }
              </div>
            }
          </>
        }
      </VerticalTimelineElement>
    </>
    );
  };

  const timeline = (trackingData) => {
    const currentTracking = trackingData.find((track) => track.current_status === 'S');
    const timelineLayout = currentTracking && currentTracking.partialized === 'S' ? '1-column-left' : '2-columns';
    return <VerticalTimeline lineColor='grey'
      layout={timelineLayout}>
      {trackingData.map((tracking, index) => {
        if (showTrackingCard(tracking)) {
          return getTimelineCard(tracking, currentTracking, index);
        }
      })
      }
    </VerticalTimeline>;
  };

  return (
    <Modal size='fullscreen' key={`tracking-modal-${key}`}
      onOpen={(e) => openTrackingModal(e)}
      onClose={(e) => closeTrackingModal(e)}
      open={open}
      trigger={
        <span className='link' key={`tracking-modal-trigger-${key}`}>
          <Popup
            trigger={<Icon name='search' size='huge' color='blue' />}
            content='Consultar Tracking'
            position='top right'
            inverted
          />
        </span>
      }>

      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>Tracking factura: {invoice}</h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => closeTrackingModal(e)} />
        </div>
      </Modal.Header>
      
      <Modal.Content scrolling>
        <div className='modal-background' style={{'backgroundImage': 'url(/media/internationl-commerce-02.jpg)'}}>
          <div className='modal-overlay'>
            {timeline(invoiceTracking)}
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};
